import { render, staticRenderFns } from "./AffiliateSetting.vue?vue&type=template&id=932f1f20&"
import script from "./AffiliateSetting.vue?vue&type=script&lang=ts&"
export * from "./AffiliateSetting.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports